<!--  https://docs.google.com/presentation/d/1HohiaRNK0Dk8AEpfZfq9BqFElUspgneZoL32sH0roaY/edit#slide=id.g13a98364a97_0_0 
      https://docs.google.com/presentation/d/1-DHTsYQrfo1o8cQQ9M3UsSdN9fceGsChvWXyE4TXoXc/edit#slide=id.g1466430903c_0_21 -->
<!--  https://xd.adobe.com/view/9855918d-37f4-4e55-8d30-7c4332d93d0a-cd06/screen/1ee1fc0e-13cb-4d73-8a09-cee56d1fbfff/ -->
<!--- https://xd.adobe.com/view/d5f8535e-dbaf-4e17-996f-ec324507552a-80ab/screen/09aa1f55-eecd-4c2b-84de-0c91677d90ef/specs/ latest -->
<template>
  <div id="projectwizardv2" class="clearfix px2 notosans ">
    <div v-if="project_id !== undefined">
      <p class="h5 pt3 darkblue semi-bold  line-height-golden">Opdater projekt:<br>
        <span class="h3 regular">{{ title }}</span>
      </p>
    </div>
    <div v-if="success">
      <p class="h4  semi-bold darkblue line-height-3">
        Gennemført!
      </p>
      <p class="h5 darkblue regular  line-height-golden" v-if="project_id === undefined">
        Dit projekt er tilføjet.
      </p>
      <p class="h5 darkblue regular  line-height-golden" v-if="project_id !== undefined">
        Dit projekt er opdateret.
      </p>
      <div class="py2 flex flex-column">
        <span class="h6 regular  mediumgrey block m0">Projekt Url: </span>
        <p class="h4 semi-bold darkblue line-height-golden mb0">{{url}}</p>
      </div>
      <div>
        <button href="javascript:void(0)" class="col-12 facebook-button p1 py2 mt3 pointer no-hover flex justify-start items-center" @click="facebokUrl(url)">
          <span class="mr1 relative" style="top:-4px;">
            <img src="/static/svg/facebook.svg" alt="" width="20" height="20">
          </span>
          <span class="h6 semi-bold mb0 white left-align pl1">Del dit projekt på Facebook</span>
        </button>
        <button v-clipboard:copy="url" v-clipboard:success="successCopy" v-clipboard:error="onErrorCopy" class="col-12 action-button p2 h5 my2 flex justify-center itemws-center ">
          <span class="regular">Kopiér url</span>
          <span class="ml1"><i class="el-icon-right"></i></span>
        </button>
      </div>
    </div>
    <div class="mt1 lg-col-11 lg-col-11 lg-col-11 xs-col-12 mx-auto p0 m0">
      <form-wizard ref="wizard" title="" v-if="!success" subtitle="" shape="circle" color="rgba(25, 163, 192, 1.0)" error-color="rgba(207,0,15,1.0)" finishButtonText="Bekræft">
        <tab-content title="1 ud af 4" :before-change="validateFirstStep">
          <div class="">
            <p class="h4 darkblue col-12 center line-height-golden">Billeder</p>
            <p :show="noImage" class="h5 col-12 center darkblue regular  mb2 line-height-3">
              Start med at uploade billeder
            </p>
            <p class="h6 darkblue " :v-html="images.length + ' Billede'"></p>
            <div class="clearfix flex flex-wrap mb2">
              <dropzone id="myVueDropzone" class="pointer" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
              <div v-for="image in images" :key="image.id">
                <div class="px2 flex flex-column justify-center items-center mb2">
                  <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;" v-if="project_id === undefined">
                  <img :src="image.image" alt="" class="fit mb2" style="width:100px;height:100px;" v-else>
                  <button @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="">
              <projectimages :project="project" @moveImage="SaveImage" @Reload="Reload" @delete_image="delete_image_other" @rorate_image="rorate_image"></projectimages>
            </div> -->
          <div class="col-12 px0">
            <div class="flex justify-start items-center py1 border muted-border mediumgrey shadow mb2">
              <div class="flex-none px2">
                <svg class="relative" style="top:3px;" width="18" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path class="st0" d="M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"/></svg>
              </div>
              <input class="searchBox gibson h6 darkblue regular mb0 p2 col-10 pl0" type="search" name="search" v-model="search" placeholder="Søg opgavetype" style="background:transparent;border:0px!important;">
              <!-- <input type="submit" value="Search" class="action-button"> -->
            </div>
          </div>
          <div class="col-12 p0 m0 mt2">
              <div class="flex flex-wrap" style="gap:10px;">
                <div v-for="(mainitem,index) in taskoptions" :id="'divsubbrancheitems' + index"  :key="mainitem.taskTypeId">
                    <!-- <button @click="selectmaintask(mainitem)" class="buttonmaintask ml1 mb1 p1" :id="'button' + mainitem.BRANCHE_ID">
                        <span class="h6 regular inline-block center p0 m0">{{ mainitem.BRANCHE }}</span>
                    </button> -->
                    <!-- <button @click="selectmaintask(mainitem)" class="buttonmaintask p1" :id="'button' + mainitem.taskTypeId">
                        <span class="h6 regular inline-block center p0 m0">{{ mainitem.name }}</span>
                    </button> -->
                    <button @click="selectmaintaskkundematch(mainitem)" class="buttonmaintask p1" :id="'button' + mainitem.TaskTypeId">
                        <span class="h6 regular inline-block center p0 m0">{{ mainitem.TaskTypeName }}</span>
                    </button>
                </div>
              </div>
          </div>
          <div class="py2 col-12 px0">
                <p class="h5">Valgt opgavetype</p>
                <button v-for="(selectedmans,index) in tasktype" :key="index" :disable-transitions="false" class="p1 mr1 mb1 darkblue-background center relative " :id="'manbutton' + selectedmans.TaskTypeId">
                    <p class="mr1 h6 mb0 p0 line-height-1 inline-block regular white px2" style="text-transform:capitalize;">{{selectedmans.TaskTypeName}}</p>
                    <p class="absolute right-0 top-0">
                        <span @click="removetaskkundematch(selectedmans)" class="white block m0 p0 line-height-1 no-hover">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close">
                                <path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                        </span>
                    </p>
                </button>
              </div>
        </tab-content>
        <tab-content title="2 ud af 4" :before-change="validateSecondStep">
          <div class="clearfix col-12 mb3">
            <p class="h4 darkblue col-12 m0 p0 line-height-golden center">Projektinformationer</p>
            <p class="h5 darkblue col-12 m0 p0 line-height-golden center">Her kan du oprette projekter ved at uploade billeder af dit arbejde og skrive hvad du har lavet på opgaven.</p>
          </div>
          <div class="clearfix flex flex-column col-11 mx-auto mb2 m0 p0">
            <p class="darkblue  line-height-1 mb1">
              <span>Opgavetype:</span><span class="red">*</span>
            </p>
            <div class="col-12 m0 p0">
              <button class="smallbutton darkblue ml1 mb1" v-for="item in tasktype" :key="item.ID">
                {{item.TaskTypeName}}
              </button>
            </div>
          </div>
          <el-form id="createprojectform" :model="createprojectform" class=" p0 m0 md-col-11 lg-col-11 sm-col-11 xd-col-12 mx-auto" :rules="createprojectformrule" ref="createprojectform" label-position="top">
            <div class="flex flex-row mobile-flex-column">
                <div class="m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12">
                  <el-form-item label="Titel Field" prop="title" class="border-none el-form-opgavetype  p0 mr-auto" >
                      <el-input v-model="createprojectform.title" class=" white-background" placeholder="title" clearable></el-input>
                  </el-form-item>
                </div>
            </div>
            <div class="flex flex-row mobile-flex-column" v-if="project_id === undefined">
              <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                <el-form-item label="Project oprettet" prop="projectcreated" class="border-none el-form-opgavetype  p0 mr-auto" >
                    <el-input v-model="createprojectform.projectcreated" class=" white-background" placeholder="oprettelsesdato" clearable></el-input>
                </el-form-item>
                </div>
                <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                <el-form-item label="Tid (antal dage)" id="time" prop="time" class="border-none el-form-opgavetype  ml-auto">
                    <el-input v-model="createprojectform.time"  class=" white-background" placeholder="Tre dage eller 4-6 uger" clearable></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="flex flex-row mobile-flex-column">
              <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                <el-form-item label="Pris (kr.)" prop="price" class="border-none el-form-opgavetype  p0 mr-auto" >
                    <el-input v-model.number="createprojectform.price" class=" white-background" placeholder="kr." clearable></el-input>
                </el-form-item>
                </div>
                <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                  <el-form-item label="Postnummer" id="postnummer" prop="postnummer" class="border-none el-form-opgavetype  ml-auto">
                      <el-input v-model="createprojectform.postnummer"  class=" white-background" placeholder="2300" clearable></el-input>
                  </el-form-item>
              </div>
            </div>
            <div class="m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12">
              <el-form-item label="Beskrivelse" prop="description" class="border-none el-form-opgavetype  p0 mr-auto" >
                  <el-input type="textarea" :rows="3" v-model="createprojectform.description" class=" white-background" placeholder="Beskrivelse" clearable></el-input>
              </el-form-item>
            </div>
            <!-- <div class="clearfix my3">
              <p class="darkblue  line-height-1 mb1">
                <span>Titel</span><span class="red">*</span>
              </p>
              <input class="col-12 p2 darkblue h5 inputproject not-rounded border-none" v-model="title" :state="validationTitle" type="text" required>
              <b-alert :show="validationType === false" class="p1  h5 semi-bold flex justify-start items-center red">
                <span>Required</span>
              </b-alert>
            </div>
            <div class="clearfix">
              <p class="darkblue h5  regular line-height-golden mb2">
                <span>Beskriv projektet så detaljeret som muligt (gerne med navne på produkterne, der er anvendt): </span><span class="red">*</span>
              </p>
              <b-form-textarea class="muted-background p2  h5 line-height-golden border-none not-rounded" :rows="8" v-model="description" :state="validationDescription" type="text" required ></b-form-textarea>
              <b-alert :show="validationDescription === false" variant="danger" class="p1  h5 semi-bold flex justify-start items-center red">Required</b-alert>
            </div> -->
          </el-form>
          <div class="col-12 flex flex-wrap m0 p0 px2">
            <div v-for="image in images" :key="image.id">
              <div class="px2 flex flex-column justify-center items-center mb2">
                <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;" v-if="project_id === undefined">
                <img :src="image.image" alt="" class="fit mb2" style="width:100px;height:100px;" v-else>
                <button @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                </button>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="3 ud af 4">
          <div class="p1">
              <p class="darkblue h4 semi-bold center">Producenter</p>
              <div class="col-12 my2 p2">
                  <p class="h6 center m0 p0 col-12">Index</p>
                  <div class="flex flex-wrap center justify-center items center primarycolor my2">
                      <p @click="filterbyletter(letter)" class="h4 semi-bold mx2 pointer" v-for="(letter,index) in letterarr" :key=index>{{letter}}</p>
                  </div>
              </div>
              <div class="col-12 my2">
                <div class="flex justify-start items-center py1 border muted-border mediumgrey shadow mb2">
                  <div class="flex-none px2">
                    <svg class="relative" style="top:3px;" width="18" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path class="st0" d="M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"/></svg>
                  </div>
                  <input class="searchBox gibson h4 darkblue regular mb0 p2 col-10 pl0" type="search" name="searchmanufacturer" v-model="searchmanufacturer" placeholder="Søg Fabrikant" style="background:transparent;border:0px!important;">
                  <input type="submit" value="Search" class="action-button">
                </div>
              </div>
              <div class="col-12 flex flex-wrap p2 mb2 justify-start" style="gap:10px;">
                  <button @click="selectmanufacturelist(manitem)" class="buttonmaintask p1" v-for="(manitem,index) in filteredmanufacturer" :key="index" :id="'manbuttons' + manitem.ManufactureId">
                        <span class="h6 regular inline-block center p0 m0">{{ manitem.Name }}</span>
                  </button>
              </div>
              <div class="p2 col-12">
                <p class="h5">Udvalgt producent</p>
                <button v-for="(selectedman,index) in manufacturetype" :key="index" :disable-transitions="false" class="p1 mr1 mb1 darkblue-background center relative " :id="'manbutton' + selectedman.ManufactureId">
                    <p class="mr1 h6 mb0 p0 line-height-1 inline-block regular white px2" style="text-transform:capitalize;">{{selectedman.Name}}</p>
                    <p class="absolute right-0 top-0">
                        <span @click="removeMan(selectedman)" class="white block m0 p0 line-height-1 no-hover">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close">
                                <path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                        </span>
                    </p>
                </button>
              </div>
          </div>
        </tab-content>
        <template slot="footer" slot-scope="props" class="flex">
          <div class="wizard-footer-left col-6 px0">
            <wizard-button :style="props.fillButtonStyle" v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" class="wizard-footer-left">
              <span><i class="el-icon-back"></i></span>
              <span class="h4 line-height-1 ml2 semi-bold mb0">Tilbage</span>
            </wizard-button>
            <!-- <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" :style="props.fillButtonStyle">Previous</wizard-button> -->
          </div>
          <div class="wizard-footer-right col-6 px0">
            <wizard-button :style="props.fillButtonStyle" v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right">
              <span class="h4 line-height-1 mr2 semi-bold mb0">Næste</span>
              <span><i class="el-icon-right"></i></span>
            </wizard-button>
            <wizard-button type="button" v-else @click.native="onComplete" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{props.isLastStep ? 'Færdig' : 'Næste'}}</wizard-button>
          </div>
        </template>
      </form-wizard>
      <div class="py4"></div>
      <div class="py4 lg-hide sm-hide"></div>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import VueFormWizard from 'vue-form-wizard'
import Dropzone from 'vue2-dropzone'
import vSelect from 'vue-select'
import VueClipboard from 'vue-clipboard2'
import projectimages from './../uploads/projectimages'
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'createnew',
  props: ['projects', 'projects_create'],
  components: {
    VueClipboard,
    projectimages,
    loading,
    Simplert,
    Dropzone,
    vSelect,
    VueFormWizard,
    ErrorHandler
  },
  computed: {
    dropzoneSettings () {
      let defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      }
      Object.keys(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key]
      }, this)
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false
        this.isS3 = true
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue
        }
      }
      return defaultValues
    }
  },
  watch: {
    'tasktype': function (newVal, oldVal) {
      if (newVal.length !== 0) {
        this.validationType = true
      }
    },
    'search': function (newVal, oldVal) {
      if (newVal.length > 2) {
        setTimeout(() => {
          // this.filtersearch(newVal)
          this.filtersearchkundematch(newVal)
        }, 200)
      } else {
        // this.subtaskoptions = this.suboptions
        this.taskoptions = this.taskoptionsmain.slice(0, 30)
      }
    },
    'searchmanufacturer': function (newVal, oldVal) {
      if (newVal.length > 1) {
        setTimeout(() => {
          this.filtermanufacturersearch(newVal)
        }, 200)
      } else {
        this.filteredmanufacturer = this.manufactureoptions.slice(0, 30)
      }
    },
    'title': function (newVal, oldVal) {
      if (newVal !== '') {
        this.validationTitle = true
      }
    },
    'description': function (newVal, oldVal) {
      if (newVal !== '') {
        this.validationDescription = true
      }
    }
  },
  data: function () {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: false,
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class=" regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor  line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      project_id: '',
      projectType: null,
      Producenter: 0,
      title: '',
      tasktype: [],
      manufacturetype: [],
      project: [],
      description: '',
      price: '',
      url: 'fgd',
      time: '',
      postnummer: '',
      fmans: {
        name: '',
        email: '',
        mobile: ''
      },
      mans: [],
      ProducenterOptions: [],
      manufactureoptions: [],
      images: [],
      taskoptions: [],
      pimages: [],
      projectOptions: [
        'Badeværelse',
        'Gulv',
        'Koekken',
        'Tag',
        'Terrasse',
        'Udestue',
        'Vinduer',
        'Andet'
      ],
      seen: false,
      noImage: false,
      startEdit: false,
      validationType: '',
      validationTitle: '',
      validationDescription: '',
      show: false,
      label: 'Loading...',
      overlay: true,
      salesPerson: '',
      salesPersonbitrix: '',
      success: false,
      kunde: {
        title: '',
        name: '',
        address: '',
        zip: '',
        tlf: '',
        email: ''
      },
      maintask: [],
      subtaskoptions: [],
      selectedbrancheid: '',
      search: '',
      searchmanufacturer: '',
      createprojectform: {
        title: '',
        projectcreated: '',
        time: '',
        price: '',
        postnummer: '',
        description: ''
      },
      createprojectformrule: {
        title: [{
          required: true,
          type: 'string',
          message: 'Indtast venligst din projekttitel',
          trigger: 'blur'
        }],
        projectcreated: [{
          required: true,
          type: 'string',
          message: 'Indtast venligst dit projekts oprettelsesdato',
          trigger: 'blur'
        }],
        time: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit tid',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit pris',
          trigger: 'blur'
        }],
        postnummer: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit beskrivelse',
          trigger: 'blur'
        }]
      },
      letterarr: [],
      filteredmanufacturer: [],
      taskoptionsmain: []
    }
  },
  created () {
    this.Reload()
    // this.gettaskbitrix()
    this.project_id = this.$route.query.id
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1000) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
  },
  methods: {
    onFinished: function () {
      alert('Yay. Done!')
    },
    isLastStep () {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep
      }
      return false
    },
    facebokUrl (url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank')
    },
    successCopy () {
      let obj = {
        title: 'Url er nu kopieret.',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
    },
    onErrorCopy () {
      alert('Kan ikke kopiere')
    },
    validateFirstStep () {
      if (this.images.length === 0) {
        this.noImage = true
        this.$message({
          type: 'error',
          message: 'Tilføj venligst mindst 1 billedee'
        })
        return false
      }
      if (this.tasktype.length < 1) {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en opgave'
        })
        return false
      }
      return true
    },
    gettaskbitrix () {
      this.salesPersonbitrix = localStorage.getItem('token_portal_bitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      this.$http.get(this.$bitrixapi + 'industries/full/' + this.haaId, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.maintask = res.data
            var itemssub = []
            this.maintask.forEach(a => {
              a.SubIndustries.forEach(b => {
                if (b.taskTypes && b.taskTypes.length > 0) {
                  b.taskTypes.forEach(c => {
                    itemssub.push(c)
                  })
                }
              })
            })
            this.suboptions = itemssub
            this.subtaskoptions = itemssub.slice(0, 30)
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    selectmaintask (arr) {
      // if (this.selectedbrancheid !== arr.SUBCATEGORY_ID) {
      //   if (this.selectedbrancheid !== '') {
      //     document.getElementById('button' + this.selectedbrancheid).classList.remove('buttonselected')
      //   }
      //   document.getElementById('button' + arr.SUBCATEGORY_ID).classList.add('buttonselected')
      //   this.selectedbrancheid = arr.SUBCATEGORY_ID
      //   this.tasktype.push(arr)
      // }
      if (this.tasktype.indexOf(arr) < 0) {
        this.tasktype.push(arr)
        this.suboptions.splice(this.suboptions.indexOf(arr), 1)
        this.subtaskoptions.splice(this.subtaskoptions.indexOf(arr), 1)
      }
    },
    selectmaintaskkundematch (arr) {
      // if (this.selectedbrancheid !== arr.SUBCATEGORY_ID) {
      //   if (this.selectedbrancheid !== '') {
      //     document.getElementById('button' + this.selectedbrancheid).classList.remove('buttonselected')
      //   }
      //   document.getElementById('button' + arr.SUBCATEGORY_ID).classList.add('buttonselected')
      //   this.selectedbrancheid = arr.SUBCATEGORY_ID
      //   this.tasktype.push(arr)
      // }
      if (this.tasktype.indexOf(arr) < 0) {
        this.tasktype.push(arr)
        this.taskoptionsmain.splice(this.taskoptionsmain.indexOf(arr), 1)
        this.taskoptions.splice(this.taskoptions.indexOf(arr), 1)
      }
    },
    selectmanufacturelist (manitem) {
      if (this.manufacturetype.indexOf(manitem) < 0) {
        this.manufacturetype.push(manitem)
        this.manufactureoptions.splice(this.manufactureoptions.indexOf(manitem), 1)
        this.filteredmanufacturer.splice(this.filteredmanufacturer.indexOf(manitem), 1)
      }
    },
    filtersearch (type) {
      var filtertype = []
      filtertype = this.suboptions.filter((z) => {
        return z.name.toLowerCase().includes(type.toLowerCase())
      })
      this.subtaskoptions = filtertype
    },
    filtersearchkundematch (type) {
      var filtertype = []
      filtertype = this.taskoptionsmain.filter((z) => {
        return z.TaskTypeName.toLowerCase().includes(type.toLowerCase())
      })
      this.taskoptions = filtertype
    },
    filtermanufacturersearch (text) {
      var filtertypemanu = []
      filtertypemanu = this.manufactureoptions.filter((m) => {
        return m.Name.toLowerCase().includes(text.toLowerCase())
      })
      this.filteredmanufacturer = filtertypemanu
    },
    filterbyletter (letter) {
      var filtermanufacturer = []
      filtermanufacturer = this.manufactureoptions.filter((n) => {
        return n.Name.charAt(0).toUpperCase() === letter
      })
      this.filteredmanufacturer = filtermanufacturer
    },
    removeMan (manarr) {
      this.filteredmanufacturer.push(manarr)
      this.manufactureoptions.push(manarr)
      this.manufacturetype.splice(this.manufacturetype.indexOf(manarr), 1)
    },
    removetask (taskarr) {
      this.suboptions.push(taskarr)
      this.subtaskoptions.push(taskarr)
      this.tasktype.splice(this.tasktype.indexOf(taskarr), 1)
    },
    removetaskkundematch (taskarr) {
      this.taskoptions.push(taskarr)
      this.taskoptionsmain.push(taskarr)
      this.tasktype.splice(this.tasktype.indexOf(taskarr), 1)
    },
    validateSecondStep () {
      var error = 0
      this.$refs['createprojectform'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) {
        return false
      }
      return true
    },
    onComplete () {
      this.show = true
      var manufacturelist = []
      for (var i = 0; i < this.manufacturetype.length; i++) {
        var c = this.manufacturetype[i]
        manufacturelist.push(c.ManufactureId)
      }
      var tasktypelist = []
      for (var j = 0; j < this.tasktype.length; j++) {
        var z = this.tasktype[j]
        tasktypelist.push(z.TaskTypeId)
      }
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {
        operation: 'addProjectothernew',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        title: this.createprojectform.title,
        description: this.createprojectform.description,
        images: JSON.stringify(this.images),
        tasktypelist: JSON.stringify(tasktypelist),
        manufacturelist: JSON.stringify(manufacturelist),
        postnummer: this.createprojectform.postnummer,
        price: this.createprojectform.price,
        time: this.createprojectform.time,
        projectid: this.project_id
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              this.url = res.url
              this.success = true
              this.$router.push('/opret-projekt-new/tak?projecturl=' + encodeURI(res.url))
            } else {
              let obj = {
                title: 'Fejl',
                message: 'Fejl - Kontakt venligst administrator',
                type: 'error'
              }
              this.$refs.simplert.openSimplert(obj)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    change_position (imageId, projectid) {
    },
    delete_image (image) {
      const index = this.images.indexOf(image)
      if (index > -1) {
        this.images.splice(index, 1)
      }
    },
    'showSuccess': function (file) {
      this.noImage = false
      this.images.push(file.xhr.response)
    },
    sendingEvent (file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      formData.append('salesPerson', this.salesPerson)
      formData.append('levid', this.haaId)
      formData.append('operation', 'uploadImagesPrevProject')
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      this.project_id = this.$route.query.id
      this.show = true
      var data = {operation: 'myProjectInfo', salesPerson: this.salesPerson, levid: this.haaId, projectid: this.project_id}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.show = false
            this.$emit('UpdateProject', res.projects, res.projects_create)
            this.ProducenterOptions = res.center
            this.Producenter = res.selected
            this.taskoptionsmain = res.TaskType
            this.taskoptions = res.TaskType.slice(0, 30)
            this.manufactureoptions = res.manufacture
            this.filteredmanufacturer = res.manufacture.slice(0, 30)
            var letters = []
            res.manufacture.forEach(a => {
              letters.push(a.Name.charAt(0).toUpperCase())
            })
            const unique = (value, index, self) => {
              return self.indexOf(value) === index
            }
            this.letterarr = letters.filter(unique).sort()
            if (this.project_id !== undefined) {
              this.project = res.project
              this.createprojectform.title = res.project.title
              this.createprojectform.description = res.project.description
              if (res.project.manufacturetype !== null) {
                for (var i = 0; i < res.manufacture.length; i++) {
                  var c = res.manufacture[i]
                  if (res.project.manufacturetype.includes(c.ManufactureId)) {
                    this.manufacturetype.push(c)
                  }
                }
              }
              if (res.project.tasktype !== null) {
                for (var j = 0; j < res.TaskType.length; j++) {
                  var d = res.TaskType[j]
                  if (res.project.tasktype.includes(d.TaskTypeId)) {
                    this.tasktype.push(d)
                  }
                }
              }
              var datanow = new Date()
              this.createprojectform.postnummer = res.project.postnummer
              this.createprojectform.price = Number(res.project.price)
              this.createprojectform.time = res.project.time
              this.createprojectform.projectcreated = datanow.getDate()
              this.images = res.project.images
            }
          },
          response => {
            this.show = false
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        )
    },
    delete_image_other (imageId, projectid) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'delete_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    rorate_image (imageId, projectid, image, primary) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'rotate_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        primary: primary,
        image: image,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    SaveImage (imageId, projectid) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'image_position_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    onSubmitKundeInfo (evt) {
      evt.preventDefault()
      alert(JSON.stringify(this.kunde))
      console.log(this.kunde)
      console.log(JSON.stringify(this.kunde))
    },
    resetForm (evt) {
      evt.preventDefault()
      Object.assign(this.$data, this.$options.data.call(this))
    },
    buyProjects () {
      this.$router.push('/purchase')
    }
  }
}
</script>
<style >
  #projectwizardv2 .dropzone .dz-preview .dz-progress {
    top: 0;
    left: 50%;
  }
  #projectwizardv2 .dropzone .dz-preview .dz-image {
    padding-top: 1.5em;
  }
  #projectwizardv2 .searchBox:focus {
    border: none;
  }
  #projectwizardv2 .dz-preview {
    display: block!important;
  }
  #projectwizardv2 {
    font-family: 'noto-sans', sans-serif;
  }
  #projectwizardv2 .el-form-item__label {
    margin: 0px;
    padding: 0px;
    font-size: 17px;
    color: #003645;
    font-weight: 600;
  }
  #projectwizardv2 .buttonmaintask {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 20px #00000005;
    border: 1px solid #003645;
    border-radius: 1px;
    opacity: 1;
    color: #003645;
  }
  #projectwizardv2 .buttonmaintask:hover {
    background: #003645 0% 0% no-repeat padding-box;
    border: 1px solid #003645;
    color: #fff
  }
  #projectwizardv2 .smallbutton {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 20px #00000005;
    border: 0.5px solid #003645;
    border-radius: 1px;
    opacity: 1;
  }
  #projectwizardv2 .inputproject {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 20px #00000005;
    border: 1px solid #19A3C080;
    border-radius: 1px;
    opacity: 1;
  }
  #projectwizardv2 .vue-form-wizard.md .wizard-icon-circle {
    width: 40px;
    height: 40px;
    font-size: 14px;
    font-style: normal;
  }
  #projectwizardv2 .vue-form-wizard.md .wizard-nav-pills>li.active>a .wizard-icon {
    font-size: 16px;
    font-style: normal;
  }
  #projectwizardv2 .vue-form-wizard .wizard-nav-pills>li.active>a, .vue-form-wizard .wizard-nav-pills>li.active>a:focus, .vue-form-wizard .wizard-nav-pills>li.active>a:hover {
    text-decoration: none;
  }
  #projectwizardv2 .vue-form-wizard .wizard-icon-circle {
    border: 4px solid #f3f2ee;
  }
  #projectwizardv2 .buttonselected {
    background: #003645 0% 0% no-repeat padding-box !important;
    color: #fff!important;
  }
  #projectwizardv2  .vue-form-wizard {
    padding-bottom: 2rem;
    margin-bottom: 2rem;
  }

  #projectwizardv2  .vue-dropzone {
    width:100%;
    padding: 0;
    border: 0;
    background: white;
  }
  #projectwizardv2  .vue-dropzone:hover {
      background: white;
  }
  #projectwizardv2 .vs__dropdown-toggle {
    border:0;
    background: rgba(230, 234, 235, 0.5);
    width:100%;
  }
  #projectwizardv2 .vue-form-wizard .wizard-tab-content {
    padding-top: 50px!important;
  }
  #projectwizardv2 .wizard-progress-with-circle {
    display: inherit;
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    top: 27px;
    font-style: normal;
  }
  #projectwizardv2 .vue-form-wizard .wizard-nav-pills {
      display: flex;
      width: 70%;
      margin-left: auto;
      margin-right: auto;
  }
  #projectwizardv2 .wizard-footer-left .wizard-btn {
    border: 1px solid rgba(178,190,195, 0.5)!important;
    color: rgba(178,190,195, 0.5)!important;
    background-color: #00968808!important;
    padding: 1rem!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    font-family: 'noto-sans', sans-serif;
    font-weight: 600!important;
  }
  #projectwizardv2 .wizard-footer-left .wizard-btn:hover {
      background: rgba(178,190,195, 0.5);
      color: white;
    }
  #projectwizardv2  .wizard-footer-right .wizard-btn {
    background: rgba(77, 207, 85, 1.0)!important;
    background-color: rgba(77, 207, 85, 1.0)!important;
    color: #fff;
    padding: 1rem!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    font-family: 'noto-sans', sans-serif;
    font-weight: 600!important;
  }
  #projectwizardv2 .stepTitle {
    display: none;
    width:100%;
    color: lighten(#5a5a5a, 40%);
    background-color: #fff;
    border-bottom: 3px solid lighten(#5a5a5a, 60%);
    padding: 1rem .25rem 0.5rem 1rem;
    text-align: left;
    font-weight:400;
    font-size: 13.5px;
  }
  #projectwizardv2  .wizard-nav .stepTitle.active {
    background-color: #fff;
    color: lighten(#5a5a5a, 40%)!important;
    border-bottom: 3px solid rgba(77, 207, 85, 1.0);
  }
  #projectwizardv2  .wizard-nav .stepTitle::after {
    height: 0;
  }
  #projectwizardv2  .wizard-nav .checked + .stepTitle {
    color: rgba(77, 207, 85, 1.0);
    border-bottom: 3px solid rgba(77, 207, 85, 1.0);
  }
  #projectwizardv2  .wizard-icon-circle.checked {
    background: rgb(25, 163, 192)!important;
    color: #fff!important;
  }
  #projectwizardv2 .wizard-nav {
    z-index: 2;
  }
  #projectwizardv2 .wizard-nav li:first-child:before {
    left: 0;
  }
  #projectwizardv2 .wizard-nav li:first-child:before{
    width: 50%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 0;
    background: #fff;
    content: '';
    display: block;
  }
  #projectwizardv2 .wizard-nav li:last-child:before {
    right: 0;
  }
  #projectwizardv2 .wizard-nav li:last-child:before {
      width: 50%;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 0;
      background: #fff;
      content: '';
      display: block;
  }
  #projectwizardv2 .wizard-progress-with-circle {
    display: inherit!important;
  }
  #projectwizardv2 .wizard-progress-bar {
    background: #19a3c0!important;
    position: relative;
    z-index: 2;
  }
  #projectwizardv2 .wizard-progress-with-circle:after {
    width: 100%;
    height: 1.99px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 0;
    background: #c5c5c5;
    content: '';
    display: block;
  }
  @media (max-width:27em) {
    .mobile-flex-column {
      flex-direction: column!important;
      align-items: center;
    }
    #projectwizardv2 .dropzone .dz-preview .dz-image {
      padding-top: 1.8em;
    }
  }
  #projectwizardv2 .wizard-nav {
    display: flex!important;
  }
  #projectwizardv2 .wizard-progress-with-circle {
    display: block!important;
  }
  #projectwizardv2 .vue-dropzone {
    font-family: 'noto-sans',sans-serif!important;
  }
</style>



// WEBPACK FOOTER //
// CreateProjectNew.vue?5887d5c0